// 登录组件
<template>
  <div class="box">
    <div class="content" :style="{ height: windowHeight + 'px' }">
      <div class="title">
        <p>您好,</p>
        <p>欢迎使用会议签到系统</p>
      </div>
      <div class="logoDiv">
        <h2>请填写报名人信息</h2>
      </div>

      <div class="login-box">
        <div class="icon">
          <i class="el-icon-user"></i>
          <van-field class="input-item" v-model.trim="uname" clearable placeholder="请输入报名人姓名">
          </van-field>
        </div>
        <div class="icon">
          <i class="el-icon-mobile-phone"></i>
          <van-field class="input-item" v-model="mobile" center clearable placeholder="请输入报名人手机号">
          </van-field>
        </div>

        <div v-if="confirmWords == '验证失败'">
          <van-notice-bar class="errortips" color="#000" background="#ffeeee" left-icon="info-o">
            {{ error }}
          </van-notice-bar>
          <!-- <div style="background-color: #ffeeee;" >验证失败，未检测到报名的会议活动。</div> -->
          <div class="helps" style="background-color: #f2f7ff;">
            <h4>如多次失败，可尝试以下方式解决问题:</h4>
            <p>1. 登录报名系统，查看报名会议是否正确。</p>
            <p>
              2. 登录报名系统，查看报名信息填写是否正确，如填写错误，请尝试修改报名人信息。
            </p>
            <p>
              以上方式无法解决您的问题，请联系技术支持人员协助您解决，电话:17632651125
            </p>
          </div>
        </div>
        <div v-else class="drag" ref="dragDiv">
          <div class="drag_bg" :style="{ 'background-color': color === true ? 'red' : '#7ac23c' }"></div>
          <div class="drag_text">{{ confirmWords }}</div>
          <div ref="moveDiv" @touchstart="mousedownFn($event)" :class="{ handler_ok_bg: confirmSuccess }"
            class="handler handler_bg" style="position: absolute; top: 0px; left: 0px"></div>
        </div>
        <van-button :disabled="submitDisabled" class="loginBtn" type="primary" block @click="login">点击人机验证</van-button>
      </div>
      <!-- <van-divider>其他账号登录</van-divider>
      <div class="accoutDiv" @click="go('meetLogin')">
        <img src="../../assets/images/person.svg"/>
        个人账号登录
      </div> -->
    </div>
  </div>
</template>

<script>
  import { Field, Button, Toast, Divider, NoticeBar } from "vant"
  import { getUser, registerSignMeeting } from "../../../api/dictionary"
  import { getMobileLoginCode } from "@/api/login"
  import { mapActions, mapMutations } from "vuex"
  import { setSessionStore } from "@/utils/sessionStorage"

  export default {
    data() {
      return {
        windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
        windowHeight: document.documentElement.clientHeight, //实时屏幕高度
        uname: "",
        submitDisabled: false,
        password: "",
        isShowPW: true,
        screenHeightNoChange: true,
        grant_type: "sms",
        mobileLoginStatus: 2,
        time: 60,
        isSpend: false,
        isDisabled: false,
        mobile: "",
        code: "",
        userInfo: {},
        userType: 2,
        beginClientX: 0 /*距离屏幕左端距离*/,
        mouseMoveStata: false /*触发拖动状态  判断*/,
        maxwidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
        confirmWords: "拖动滑块验证" /*滑块文字*/,
        confirmSuccess: false /*验证成功判断*/,
        color: false,
        status: true,
        canuse: false,
        error: "",
      }
    },
    computed: {
      // registerType() {
      //   return this.$route.query && this.$route.query.registerType;
      // },
      meetingId() {
        return this.$route.query && this.$route.query.meetingId
        // return "f0b976a2-152a-4f5e-a929-0bea2cd93b3f"
      },
      sourc() {
        return this.$route.query && this.$route.query.sourc
      },
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Divider.name]: Divider,
      [NoticeBar.name]: NoticeBar,
    },
    methods: {
      ...mapActions(["securityCheck"]),
      ...mapMutations(["setMemberInfo"]),
      mousedownFn: function (e) {
        if (!this.confirmSuccess) {
          // e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
          this.mouseMoveStata = true
          this.beginClientX = e.changedTouches[0].clientX
          console.log("111", this.beginClientX, this.mouseMoveStata)
        }
      }, //mousedoen 事件
      successFunction() {
        this.color = false
        this.confirmSuccess = true
        this.confirmWords = "验证通过"
        this.isDisabled = false
        if (window.addEventListener) {
          document
            .getElementsByTagName("html")[0]
            .removeEventListener("touchmove", this.mouseMoveFn)
          document
            .getElementsByTagName("html")[0]
            .removeEventListener("touchend", this.moseUpFn)
        } else {
          document
            .getElementsByTagName("html")[0]
            .removeEventListener("touchend", () => { })
        }
        document.getElementsByClassName("drag_text")[0].style.color = "#fff"
        document.getElementsByClassName("handler")[0].style.left =
          this.maxwidth + "px"
        document.getElementsByClassName("drag_bg")[0].style.width =
          this.maxwidth + "px"
        // document.getElementsByClassName("drag")[0].style.display = "none";
        console.log("3触发提交函数")
        this.submit()
      }, //验证成功函数
      mouseMoveFn(e) {
        if (this.mouseMoveStata) {
          let width = e.changedTouches[0].clientX - this.beginClientX
          if (width > 0 && width <= this.maxwidth) {
            document.getElementsByClassName("handler")[0].style.left =
              width + "px"
            document.getElementsByClassName("drag_bg")[0].style.width =
              width + "px"
          } else if (width > this.maxwidth) {
            this.successFunction()
            console.log("2滑块操作到头，触发成功验证", this.mouseMoveStata)
          }
        }
      }, //mousemove事件
      moseUpFn(e) {
        if (this.canuse) {
          console.log("333")
          this.mouseMoveStata = false
          console.log("e.changedTouches[0].clientX", e.changedTouches[0].clientX)
          var width = e.changedTouches[0].clientX - this.beginClientX
          console.log("width", width, this.maxwidth)
          if (width < this.maxwidth) {
            console.log("false")
            this.confirmWords = "验证失败"
            this.error = "请重新验证"
            this.color = true
            this.status = false
            this.canuse = false
          }
        }
      }, //mouseup事件
      go(type) {
        this.$router.push({ name: type })
      },

      reginster() {
        this.$router.push({
          name: "meetRegister",
          query: { id: this.meetingId, sourc: this.sourc, registerType: 2 },
        })
      },
      mobileLogin() {
        if (this.mobileLoginStatus == 1) {
          this.mobileLoginStatus = 2
          this.grant_type = "sms"
        } else {
          this.mobileLoginStatus = 1
          this.grant_type = "password"
        }
      },
      async getCode() {
        let mobile = this.mobile

        if (this.isSpend) {
          return
        }

        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号")
          return false
        }

        getMobileLoginCode({ mobile }).then((res) => {
          if (res.success) {
            this.isSpend = true
            this.time = 60
            this.count()
          }
        })
      },
      count() {
        --this.time
        if (this.time > 0) {
          setTimeout(() => {
            this.count()
          }, 1000)
        } else {
          this.isSpend = false
        }
      },
      submit() {
        var params = {
          name: this.uname,
          phone: this.mobile,
          meetingId: this.meetingId,
        }
        console.log("签到进入")
        console.log("params", params)
        registerSignMeeting(params)
          .then((res) => {
            console.log("params", params)
            if (res.success) {
              if (res.result.status == 2) {
                console.log("1已经签到过")
                Toast.success("您已签到，请勿重复签到")
              } else {
                Toast.success("签到成功")
                console.log("最后成功跳转")
              }
            } else {
              console.log("没成功不跳转")
              this.error = res.message
              this.submitDisabled = true
              this.confirmWords = "验证失败"
              this.color = true
              this.status = false
            }
          })
          .catch((res) => {
            if (res.error_description) {
              Toast(res.error_description)
            } else {
              Toast("该用户未注册")
            }
          })
      },
      login() {
        if (!this.uname) {
          Toast("用户名不能为空")
          return
        } else if (!this.mobile) {
          Toast("手机号不能为空")
          return
        } else if (!this.$regexp.mobile(this.mobile)) {
          Toast("请输入正确的手机号")
          return false
        } else if (this.confirmWords == "验证通过") {
          console.log("1滑块已经通过")
          Toast("您已验证通过")
          return
        } else {
          var params = {
            name: this.uname,
            phone: this.mobile,
            meetingId: this.meetingId,
          }
          console.log("params", params)
          // registerSignMeeting(params).then((res) => {
          //   console.log("params", params)

          // if (res.success) {
          //   if (res.result.status == 2) {
          //     console.log("1已经签到过")
          //     Toast.success("您已签到，请勿重复签到")
          //     // this.$router.push({ name: "MeetingList" })
          //   } else {
          // if (this.status) {
          // console.log("2没有签到过")
          this.beginClientX = 0
          this.color = false
          this.canuse = true
          this.confirmWords = "拖动滑块验证"
          document.getElementsByClassName("drag")[0].style.visibility = "visible"
          // }

          // }
          // } else {
          //   Toast(res.message)
          //   return
          // }
          // })
        }
      },
    },
    mounted() {
      var url = window.location.href //获取url中"?"符后的字串 ('?modFlag=business&role=1')
      //var url = "http://localhost:8081/#/signupSearch?meetingId=c940d6bb-0be9-4c36-afac-35078866e643";
      let begin = url.indexOf("?")
      let a = url.substring(begin, url.length)
      document.getElementsByClassName("drag")[0].style.visibility = "hidden"
      var theRequest = new Object()
      if (a.indexOf("?") != -1) {
        var str = a.substr(1) //substr()方法返回从参数值开始到结束的字符串；
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1]
        }
        const tid = theRequest.tid
        sessionStorage.setItem("tid", tid)
      }
      const self = this
      window.onresize = () => {
        if (self.oldFullHeight) {
          self.screenHeightNoChange =
            document.documentElement.clientHeight === self.oldFullHeight
        }
        if (this.clientHeight > document.documentElement.clientHeight) {
          this.showBtn = false
        } else {
          this.showBtn = true
        }
      }
      var that = this
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight
          window.fullWidth = document.documentElement.clientWidth
          that.windowHeight = window.fullHeight // 高
          that.windowWidth = window.fullWidth // 宽
        })()
      }
      this.maxwidth =
        this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth
      document
        .getElementsByTagName("html")[0]
        .addEventListener("touchmove", this.mouseMoveFn)
      // document.getElementsByClassName("drag")[0]
      document
        .getElementsByTagName("html")[0]
        .addEventListener("touchend", this.moseUpFn)
    },
    watch: {
      windowHeight(val) {
        let that = this
        console.log("实时屏幕高度：", val, that.windowHeight)
      },
      windowWidth(val) {
        let that = this
        console.log("实时屏幕宽度：", val, that.windowHeight)
      },
    },
  }
</script>

<style lang="less" scoped>
  .box {
    background-color: #fff;
  }

  .box .spanFont {
    color: #1989fa;
    font-size: 14px;
    text-align: center;
  }

  .logo {
    text-align: center;
    font-size: 18px;
    margin-top: 13%;
    color: #000;
  }

  .icon {
    padding: 10px 0;
    display: flex;
    height: 30px;
  }

  i {
    font-size: 24px;
    padding-right: 20px;
  }

  .title {
    padding-top: 50px;

    p {
      font-size: 20px;
      padding-bottom: 13px;
    }
  }

  /deep/.van-cell {
    width: 85%;
    display: inline-block !important;
    padding: 0 !important;
  }

  [class^="el-icon-"] {
    vertical-align: top;
    color: #1989fa;
  }

  /deep/.van-button--plain.van-button--primary {
    color: #1989fa;
    background-color: #fff;
  }

  /deep/.van-button--primary {
    border-radius: 20px;
    background-color: #1989fa;
    border: 0.02667rem solid #1989fa;
  }

  /deep/.van-icon-info-o::before {
    color: red;
  }

  .errortips {
    padding: 0 10px;
    margin-bottom: 15px;
  }

  .helps {
    padding: 10px;
    font-size: 14px;

    h4 {
      margin-bottom: 10px !important;
      color: #000 !important;
    }

    p {
      line-height: 25px;
    }
  }

  .content {
    padding: 0 25px;
    background: #fff;
  }

  .content>.logoDiv {
    padding-top: 45px;
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    h2 {
      font-size: 16px;
      font-weight: normal;
      font-family: PingFangSC-regular;
    }
  }

  .handler_bg {
    background: #fff url("../../../assets/images/user/arrow.png") no-repeat center;
  }

  .handler_ok_bg {
    background: #fff url("../../../assets/images/user/chenggong.png") no-repeat center;
  }

  .drag {
    display: inline-block;
    vertical-align: middle;
  }

  .drag {
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 41px;
    line-height: 40px;
    text-align: center;
  }

  .handler {
    width: 40px;
    height: 38px;
    border: 1px solid #ccc;
    cursor: move;
  }

  .drag_bg {
    background-color: #7ac23c;
    height: 40px;
    width: 0px;
  }

  .drag_text {
    font-size: 16px;
    position: absolute;
    top: 0px;
    width: 100%;
    text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
  }

  .content>.logoDiv span {
    margin-top: 5px;
    font-size: 16px;
    margin-left: 10px;
  }

  .content>.logoDiv img {
    display: block;
    width: 46%;
  }

  .content h4 {
    font-size: 13px;
    color: #666;
    text-align: left;
    line-height: 24px;
    margin-bottom: 30px;
  }

  .content h4 b {
    color: blue;
    text-decoration: underline;
    margin-top: 5px;
    display: inline-block;
    font-weight: normal;
  }

  .login-box {
    padding-bottom: 30px;
  }

  .loginBtn {
    margin-top: 20px !important;
  }

  .btn-list {
    display: flex;
    margin: 30px 0;
    font-size: 14px;
    justify-content: space-between;
    color: #7d7d7d;
  }

  /deep/.van-divider {
    font-size: 16px;
  }
</style>